import { render, staticRenderFns } from "./SignaturePanel.vue?vue&type=template&id=adff0314&scoped=true"
import script from "./SignaturePanel.vue?vue&type=script&lang=js"
export * from "./SignaturePanel.vue?vue&type=script&lang=js"
import style0 from "./SignaturePanel.vue?vue&type=style&index=0&id=adff0314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adff0314",
  null
  
)

export default component.exports